import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function updateUser(id: number, isSuperuser: boolean, isStaff: boolean, isSupport: boolean, groups: string[]): Promise<void> {
    const dataEncoded = groups.map((group) => window.btoa(encodeURIComponent(group)));

    if (!api.userApi) {
        return;
    }

    await api.userApi.usersPartialUpdate(id, isSuperuser, isStaff, isSupport, dataEncoded).then((response) => {
        if (response instanceof Error || (response.message && response.message.error)) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response);
            } else {
                store.doNotice(lang[response.message.error]);
            }
            return;
        }

        store.doNotice(lang.updateUser, true);
    });
}

export { updateUser };
